import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.919 21C16.22 21 20.76 14.074 20.76 8.068c0-.196 0-.392-.013-.587A9.22 9.22 0 0 0 23 5.128a8.961 8.961 0 0 1-2.592.715 4.555 4.555 0 0 0 1.984-2.513 9.008 9.008 0 0 1-2.866 1.103 4.495 4.495 0 0 0-5.423-.895 4.56 4.56 0 0 0-2.27 5.04 12.785 12.785 0 0 1-9.302-4.749A4.567 4.567 0 0 0 3.93 9.896a4.457 4.457 0 0 1-2.049-.568v.057a4.539 4.539 0 0 0 3.621 4.455 4.476 4.476 0 0 1-2.038.078 4.523 4.523 0 0 0 4.217 3.157A9.017 9.017 0 0 1 1 18.958a12.715 12.715 0 0 0 6.919 2.038"
});

var SvgTwitter = function SvgTwitter(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgTwitter;